export const contentData = {
  spanish:{
    layout:{
      title:'Editar Distribuidor',
      navigation:[
        {name:'Catálogos',path:'/catalogs'},
        {name:'Distribuidores',path:'/catalogs/providers'},
        {name:'Detalles',path:'/catalogs/providers/:id'},
        {name:'Editar',path:'/catalogs/providers/:id/edit'}
        
      ],
      menu2:[
        {id:0, label:'Mis datos'},
        {id:1, label:'Horario'},
      ],
    },
  }
}